'use client';

import Script from 'next/script';
import {useEffect} from 'react';
import {sendScriptLoadErrorReport} from '@/lib/utils/scriptLoadError.utils';
import {isBrowser} from '../utils/page.utils';
import {setSessionSource, setSessionTimestamp} from '../utils/analytics';

export const Tracking = ({nonce, locale}: {nonce: string; locale: string}) => {
	const trackingEnabled = Boolean(
		(!process.env.NEXT_PUBLIC_TRACKING_DISABLED ||
			process.env.NEXT_PUBLIC_TRACKING_DISABLED === 'false') &&
			process.env.NEXT_PUBLIC_TRACKING_BASE
	);

	useEffect(() => {
		setSessionTimestamp();
		setSessionSource();
	}, []);

	if (isBrowser()) {
		try {
			window._epicTrackingAppName =
				process.env.NEXT_PUBLIC_TRACKING_NAME || 'EPICWEBTRACKING';
		} catch {
			console.warn('Failed to set window._epicTrackingAppName');
		}
	}

	if (trackingEnabled) {
		// root._epicEnableCookieGuard = true;
		// root.__tracking_base = process.env.NEXT_PUBLIC_TRACKING_BASE;

		return (
			<Script
				nonce={nonce}
				key="tracking-script"
				src={`${process.env.NEXT_PUBLIC_TRACKING_BASE}/tracking.js?l=${locale}`}
				onError={sendScriptLoadErrorReport}
				async
			/>
		);
	}

	return null;
};
